export default __webpack_public_path__ + "static/media/screen4.9f205600.png";